// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";  
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC7fbk0TZvb8iQVNELJS0hJYxuc1XoXJrQ",
  authDomain: "mv-profiles-dev.firebaseapp.com",
  projectId: "mv-profiles-dev",
  storageBucket: "mv-profiles-dev.firebasestorage.app",
  messagingSenderId: "959685280830",
  appId: "1:959685280830:web:10cb398a0b37e286d7fd6f"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
